export { default } from "./TableFooter.mjs";
export { default as tableFooterClasses } from "./tableFooterClasses.mjs";
export * from "./tableFooterClasses.mjs";